// extracted by mini-css-extract-plugin
export default {"agentInfoAvatar":"agentInfoAvatar_jy9lL","isImageEmpty":"isImageEmpty_InBb0"};